export default {
    AttachmentComposeSPLinksCanNotShareInternally: {
        datapoint: { name: 'AttachmentComposeSPLinksCanNotShareInternally' },
    },
    AttachmentComposeSPLinks: { datapoint: { name: 'AttachmentComposeSPLinks' } },
    AttachmentComposeSPMySiteLinks: { datapoint: { name: 'AttachmentComposeSPMySiteLinks' } },
    AttachmentComposeSPLinksShouldReplaceText: {
        datapoint: { name: 'AttachmentComposeSPLinksShouldReplaceText' },
    },
    AttachmentComposeSPLinksResponseHasValidFileName: {
        datapoint: { name: 'AttachmentComposeSPLinksResponseHasValidFileName' },
    },
    AttachmentComposeSPLinkRemove: { datapoint: { name: 'AttachmentComposeSPLinkRemove' } },
    UnderTenSPLinksWhenProcessAnchorElements: {
        datapoint: {
            name: 'UnderTenSPLinksWhenProcessAnchorElements',
            customData: function (fromPaste, totalLinkCount) { return [fromPaste, totalLinkCount]; },
        },
    },
    AtLeastTenSPLinksWhenProcessAnchorElements: {
        datapoint: {
            name: 'AtLeastTenSPLinksWhenProcessAnchorElements',
            customData: function (fromPaste) { return [fromPaste]; },
        },
    },
    UnderTwentyImageElementsWhenProcessAnchorElements: {
        datapoint: {
            name: 'UnderTwentyImageElementsWhenProcessAnchorElements',
            customData: function (fromPaste, totalCount, outsideAnchorCount) { return [
                fromPaste,
                totalCount,
                outsideAnchorCount,
            ]; },
        },
    },
    AtLeastTwentyImageElementsWhenProcessAnchorElements: {
        datapoint: {
            name: 'AtLeastTwentyImageElementsWhenProcessAnchorElements',
            customData: function (fromPaste) { return [fromPaste]; },
        },
    },
    ComposeEditorIsNullDuringProcessSPLinks: {
        datapoint: {
            name: 'ComposeEditorIsNullDuringProcessSPLinks',
            customData: function (linkCount, totalLinkCount) { return [linkCount, totalLinkCount]; },
        },
    },
    GetSharingInformationFailure: {
        datapoint: {
            name: 'GetSharingInformationFailure',
            customData: function (error) { return [error]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map